export const wizardStatusItems = (instance) => {
  return {
    DRAFT: { key: 'Draf', label: instance.$t('invoice.status.draft') },
    ISSUED: { key: 'Terbit', label: instance.$t('invoice.status.issued') },
    PAID: { key: 'Dibayar', label: instance.$t('invoice.status.paid')}
  }
}